import { render } from "./UserBaseCounterTest.vue?vue&type=template&id=39f93c3a&scoped=true"
import script from "./UserBaseCounterTest.vue?vue&type=script&lang=js"
export * from "./UserBaseCounterTest.vue?vue&type=script&lang=js"

import "./UserBaseCounterTest.vue?vue&type=style&index=0&id=39f93c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f93c3a"]])

export default __exports__